module.exports = __webpack_public_path__ + "static/media/frontpage.76e841ee.png";